function getYesOrNo (bool) {
  return bool ? 'Да' : 'Нет'
}

export {
  getYesOrNo
}
